<template>
  <div>
    <span class="font-semibold" v-if="!hideLabel"> {{ $t('users.addresses.address') }}: </span>
    <span v-if="address.opStatus === 'clear'" class="text-danger font-semibold">
      {{ $t('forms.select_option') }}
    </span>
    <span v-if="address.opStatus === 'invalid'" class="text-danger font-semibold">
      {{ $t('forms.error') }}
    </span>
    <span v-if="address.opStatus === 'loading'" class="text-warning font-semibold">
      {{ $t('forms.loading') }}
    </span>
    <span v-if="address.province">
      {{ address.province }}
    </span>
    <span v-if="address.county"> - {{ address.county }} </span>
    <span v-if="address.district"> - {{ address.district }} </span>
    <span v-if="address.city"> - {{ address.city }} </span>
    <span v-if="address.borough"> - {{ address.borough }} </span>
    <span v-if="address.village"> - {{ address.village }} </span>
    <span v-if="address.street"> - {{ address.street }} </span>
    <span v-if="address.line && !hideDetails"> - {{ address.line }} </span>
    <span v-if="address.address && !hideDetails"> - {{ address.address }} </span>
    <span v-if="address.postal && !hideDetails">
      - {{ $t('users.addresses.postal') }}:{{ address.postal }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'AddressString',
  props: {
    address: {
      type: Object,
      required: true
    },
    hideDetails: {
      type: Boolean,
      default: false
    },
    hideLabel: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped></style>
